module.exports = __webpack_public_path__ + "img/nkn.4d8db60f.svg";